import { App } from '@capacitor/app';
import {createApp} from 'vue'
import myApp from './App.vue'
import router from './router';
import OneSignalVuePlugin from '@onesignal/onesignal-vue3';
import {IonicVue} from '@ionic/vue';

import VueJsTour from '@globalhive/vuejs-tour';
import '@globalhive/vuejs-tour/dist/style.css';

import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';

// Enable the accessory bar and control resize behavior
if (Capacitor.isNativePlatform()) {
    Keyboard.setAccessoryBarVisible({ isVisible: true });
    Keyboard.setResizeMode({ mode: 'body' });
}
// For Mobile Apps
// import { AdMob } from '@capacitor-community/admob';
// AdMob.initialize({
//     requestTrackingAuthorization: true, // for iOS 14+
//     testingDevices: [],                 // add device IDs for testing
//     initializeForTesting: true          // disable in production
//   });

/* Other JS */
import LoadScript from "vue-plugin-load-script";
import VueCreditCardValidation from 'vue-credit-card-validation';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

/* Theme variables */
import './theme/variables.css';
import store from './store/index';
import '/public/assets/global.css';
import axios from 'axios';

import VOtpInput from "vue3-otp-input";

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import HighchartsVue from 'highcharts-vue'

const app = createApp(myApp)
    .use(IonicVue)
    .use(router)
    .use(VueCreditCardValidation)
    .use(LoadScript)
    .use(HighchartsVue)
    .use(VueJsTour)
    .use(OneSignalVuePlugin, { appId: 'f61bcf0b-20e6-460e-94c3-aaafe699ed8d'})
    .use(store);
    axios.interceptors.request.use((config)=> {
        if (store.getters["user/isLoggedIn"]) {
             config.headers.common.Authorization = `Bearer ${store.getters["user/loggedInUser"].userToken}`;
             config.headers.common.token = store.getters["user/loggedInUser"].userToken;
        }
        return config
        }, (error) => {
            return Promise.reject(error);
        });
    
        axios.interceptors.response.use(
            (response) => {
                // Return the response if successful
                return response;
            },
            (error) => {
                // Check for 401 Unauthorized status in the response
                if (error.response && error.response.status === 401) {
                    // Perform logout action in the store
                    store.dispatch("user/logout").then(() => {
                        // Redirect to the login or logout page
                        router.push("/");
                    });
                }
                return Promise.reject(error); // Decline error for further handling if needed
            }
        );

app.component('VueDatePicker', VueDatePicker);

document.addEventListener("deviceready", OneSignalInit, false);
// Call this function when your app start
function OneSignalInit() {
    // Uncomment to set OneSignal device logging to VERBOSE  
    // window.plugins.OneSignal.setLogLevel(6, 0);
    // NOTE: Update the setAppId value below with your OneSignal AppId.
    window["plugins"].OneSignal.setAppId("f61bcf0b-20e6-460e-94c3-aaafe699ed8d");
    window["plugins"].OneSignal.setNotificationOpenedHandler(function() {
        // Notification opened – handle in app if needed
    });

    // iOS - Prompts the user for notification permissions.
    //    * Since this shows a generic native prompt, we recommend instead using an In-App Message to prompt for notification permission (See step 6) to better communicate to your users what notifications they will get.
    window["plugins"].OneSignal.promptForPushNotificationsWithUserResponse(function(accepted) {
        console.log("User accepted notifications: " + accepted);
    });

    //Add device Id to localstorage
    window["plugins"].OneSignal.getDeviceState((state) => {
        localStorage.setItem('os-user', state.userId);
    });    
}

router.isReady().then(() => {
    app.component('v-otp-input', VOtpInput).mount('#app')
});


App.addListener('appUrlOpen', function (event) {
    const slug = event.url.split('.app').pop();
    if (slug) {
        try {  
            router.push({
                path: slug,
            });
        } catch {
            // Ignore navigation errors (e.g. invalid route)
        }
    }
  });